import PropTypes from 'prop-types';
import React from 'react';
import TString from './TString';

const TitleTString = (props) =>
	<TString {...props} tagName="h1" />;

export default TitleTString;